module.exports = __webpack_public_path__ + "static/media/60.24f43494.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/60.jpg
// module id = 620
// module chunks = 0